module.exports = __webpack_public_path__ + "static/img/s1.a0ac29e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/an/s1.png
// module id = o5qb
// module chunks = 1